import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import noDataImage from '@src/assets/images/no-data.svg';
import { StyledProjectListBody } from './index.style';
import ListItem from './ListItem';

const ProjectListBody = ({
  projects,
  searchResults,
  loading,
  activeSearching,
}) => {
  const renderNoData = () => (
    <Box
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
      }}
    >
      <img src={noDataImage} alt="no data" />
    </Box>
  );

  const renderListItems = () => {
    if (!activeSearching) {
      if (projects.length === 0) {
        return renderNoData();
      }
      return projects.map((project) => (
        <ListItem key={project.id} project={project} />
      ));
    }
    if (activeSearching) {
      if (searchResults.length === 0) {
        return renderNoData();
      }
      return searchResults.map((project) => (
        <ListItem key={project.id} project={project} />
      ));
    }
    return null;
  };

  return (
    <StyledProjectListBody>
      {loading ? (
        <Box
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        renderListItems()
      )}
    </StyledProjectListBody>
  );
};

export default ProjectListBody;
